<template>
     <div class="row-12">
         <div class="col-12">
             <div style="text-align:left;">
                <h5 style="padding-top:10px;font-weight: 900;">{{$t("test_report")}}</h5>
            </div>
            <div class="row-12">
                <div class="nav nav-tabs nav-detect mb-3" id="nav-tab" role="tablist">
                    <a class="nav-link active"
                        id="nav-statistics-tab"
                        data-toggle="tab"
                        href="#nav-statistics"
                        role="tab"
                        aria-controls="nav-statistics"
                        aria-selected="false">{{$t("ai_report")}}</a>
                        <!-- 概述 -->
                        <a class="nav-link"
                        id="nav-overview-tab"
                        data-toggle="tab"
                        href="#nav-overview"
                        role="tab"
                        aria-controls="nav-overview"
                        aria-selected="false">{{$t("overview")}}</a>
                </div>
                <div class="tab-content m-tab mb-3" id="nav-tabContent">
                    <div class="tab-pane fade show active"
                        id="nav-statistics"
                        role="tabpanel"
                        aria-labelledby="nav-statistics-tab">
                        <div v-if="isLoading" style="color:red;">{{$t("txt_18")}}</div>
                        <div v-else>
                            <table class="table">
                                <thead class="thead-dark">
                                    <tr>
                                        <th>{{$t("txt_19")}}</th> <!-- RR -->
                                        <th>{{$t("txt_20")}}</th> <!-- RRV -->
                                        <th>{{$t("txt_21")}}</th> <!-- ST -->
                                        <th>{{$t("txt_22")}}</th> <!-- SYS -->
                                        <th>{{$t("txt_23")}}</th> <!-- DIAS -->
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>{{ ecg_data.rrAvg  }} ms</td>
                                        <td>{{ ecg_data.rrv }} %</td>
                                        <td>{{ ecg_data.stAvg }} ms</td>
                                        <td>{{ systolic_bp }} mmHg</td>
                                        <td>{{ diastolic_bp }} mmHg</td>
                                    </tr>
                                </tbody>
                            </table>
                            <table class="table">
                                <thead class="thead-dark">
                                <tr>
                                    <th>
                                    {{$t("txt_24")}}
                                    <!-- 心律不整机率 -->
                                    </th>
                                    <th>
                                    {{$t("txt_25")}}
                                    <!-- 心碎综合症机率 -->
                                    </th>
                                    <th>
                                    {{$t("txt_26")}}
                                    <!-- 心肌缺血机率 -->
                                    </th>
                                    <th>
                                    {{$t("txt_27")}}
                                    <!-- 心肌梗塞机率 -->
                                    </th>
                                    <th>
                                    {{$t("txt_28")}}
                                    <!-- 猝死发生机率 -->
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td>{{ (ai_data.dse3*100).toFixed(1) }} %</td>
                                    <td>{{ (ai_data.dse5*100).toFixed(1) }} %</td>
                                    <td>{{ (ai_data.dse1*100).toFixed(1) }} %</td>
                                    <td>{{ (ai_data.dse2*100).toFixed(1) }} %</td>
                                    <td>{{ (ai_data.dse4*100).toFixed(1) }} %</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="tab-pane m-pane fade"
                        id="nav-overview"
                        role="tabpanel"
                        aria-labelledby="nav-overview-tab">
                        <!-- <span>
                        <i class="fas fa-check"></i>
                        </span> -->
                        <p>{{ ai_max }}</p>
                    </div>
                 </div>
             </div>
         </div>
     </div>
</template>

<script>
export default {
    data(){
        return {
            isLoading: false,
            report_id: '',
            ai_command: '',
            ai_data: {},
            ai_max: '',
            ecg_data: {},
            systolic_bp: '',
            diastolic_bp: ''
        }
    },
    created(){
        const report = JSON.parse(sessionStorage.getItem('client_report'));
        this.report_id = report.id;
        this.systolic_bp = report.systolic_bp;
        this.diastolic_bp = report.diastolic_bp;
        this.callAI()
    },
    methods: {
        callAI(){
             const api = `${process.env.VUE_APP_APIPATH}/client/report/ai`;
            const json = {
                report_id: this.report_id,
            }
            this.$http.post(api, json).then((res) => {
                const status = res.data.Status;
                if(status === 'success'){
                    let command = ''
                    for (var key in res.data.data.row) {
                        command += key + ': ' + (res.data.data.row[key] * 100).toFixed(1) + ' % <br>'  
                    }
                    this.ai_command = command;
                    this.ai_max = res.data.data.max;
                    if(this.ai_max === 'dse5'){
                        this.ai_max = '心碎綜合症'
                    }
                    this.ai_data = res.data.data.row;
                    this.ecg_data = res.data.data.ecg;
                    this.isLoading = false;
                    // this.$emit('res', {
                    //     ai_command: this.ai_command,
                    //     ai_max: this.ai_max,
                    //     ai_data: this.ai_data,
                    //     ecg_data: this.ecg_data,
                    //     ai_isLoading: this.isLoading,
                    // })
                }
            })
        }
    }
}
</script>